import MassiaGestionConfiguration from './massia.gestion.routes';

const moduleName = 'app.gestion.configuration';

angular.module(moduleName, []).config(MassiaGestionConfiguration);

export default moduleName;
